export default "__VITE_ASSET__DIcHCmU0__"